import { ChartSkill } from './types';
import { EmployeeSkillAssociationFragment } from './../../../__generated__/graphql';
import { mapCategoryRef, mapSkillLevel } from '../common/mappings';
export const mapChartSkill = (
  src: EmployeeSkillAssociationFragment,
): ChartSkill => ({
  id: src.Id,
  skillId: src.skill.Id,
  name: src.skill.localizedName,
  level: mapSkillLevel(src.flair__Rate__c),
  monthsExperience: src.flair__Months_Experience__c ?? null,
  category: mapCategoryRef(src.skill.category),
  path: src.skill.flair__Path__c ?? null,
});
